import { render, staticRenderFns } from "./UpdateOCR.vue?vue&type=template&id=220995d1&scoped=true"
import script from "./UpdateOCR.vue?vue&type=script&lang=js"
export * from "./UpdateOCR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220995d1",
  null
  
)

export default component.exports